import { autoinject } from 'aurelia-framework';
import { DialogController } from "aurelia-dialog";
import { WebApiService } from "../../services/web-api-service";
import 'jquery';
import 'notify';
import { AppMessageService } from '../../services/app-message-service';
import { Carrier } from '../../models/carrier';

@autoinject
export class TonnageDetailsDialog {
    constructor(
        protected controller: DialogController, 
        private api: WebApiService) {
    }

    carrierId: number;
    carrierName: number;
    tonnageDetails: any[] = [];

    activate(params) {
        this.carrierId = params.carrierId;
        this.carrierName = params.carrierName;
        return this.loadTonnageDetails(params.carrierId);
    }


    loadTonnageDetails(carrierId: any): any {
        return this.api.get("Carriers", "GetCarrierShipHistoryByDivision", { carrierId: this.carrierId })
            .then(result => {
                this.tonnageDetails = JSON.parse(result.response);
            }, e => {
                alert(e.message || "Error occurred.");
            });
    }



}